import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionTargets, OEVersionFeatureAccess, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEToxnetzTargetType as OEToxnetzTargetType_, OEToxnetzStartSelectionContent} from './oe-toxnetz-consts';

export const OEToxnetzTargetType = OEToxnetzTargetType_;

export const OEToxnetzTargets = new OEVersionTargets(
    {
        [OEToxnetzTargetType.organs]: [
            OETarget.toxnetz,
            OETarget.humanLiverMicro,
            OETarget.humanLiverSinusoid,
            OETarget.humanCellEpithelium,
            OETarget.humanLiverEnzyme,
            OETarget.humanLiverEnzyme2
        ],
        [OEToxnetzTargetType.nervousSystem]: [
            OETarget.humanBrainNeuron,
            OETarget.humanBrainSynapse,
            OETarget.humanBrainACh,
            OETarget.humanBrainMembrane,
            OETarget.humanBrainPotential,
            OETarget.humanEye2,
            OETarget.humanEyeRetina,
            OETarget.humanEyeCornea,
            OETarget.sensorySystems,
            OETarget.humanEarMacro,
            OETarget.humanEarInner,
            OETarget.humanSkinEpidermis,
            OETarget.humanSkin2
        ],
        [OEToxnetzTargetType.skeleton]: [
            OETarget.humanHip2,
            OETarget.humanHand
        ],
        [OEToxnetzTargetType.formulae]: [
            OETarget.toxnetzFormelsammlung
        ]
    },
    {
        [OEToxnetzTargetType.organs]: OETarget.toxnetz,
        [OEToxnetzTargetType.nervousSystem]: OETarget.humanBrainNeuron,
        [OEToxnetzTargetType.skeleton]: OETarget.humanHip2,
        [OEToxnetzTargetType.formulae]: OETarget.toxnetzFormelsammlung
    },
    {
        [OEToxnetzTargetType.organs]: OETarget.humanLiverMicro
    }
);

export const OEToxnetzFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            organsTargetSelection: !isLicensing,
            nervousSystemTargetSelection: !isLicensing,
            skeletonTargetSelection: !isLicensing,
            formulaeTargetSelection: !isLicensing,
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.organsTargetSelection = true;
                featureAccess.nervousSystemTargetSelection = true;
                featureAccess.skeletonTargetSelection = true;
                featureAccess.formulaeTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OEToxnetzTargets);

export const OEToxnetzStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEToxnetzTargets,
    OEToxnetzStartSelectionContent
);